import { TABLE_TYPE } from '../blocks/table/table.constants'

import { faAlignLeft, faChartLine, faChartSimple, faDiagramSankey, faTable, faImage, faEarthAmerica } from '@fortawesome/pro-duotone-svg-icons'
import { colors } from '#base/js/variables.style'
import forest from '#base/assets/img/forest-plot.svg'
import sunburst from '#base/assets/img/sunburst-chart.svg'
/**
 * Blocks that can be dropped onto the page along with options when creating a new block of the given type
 *
 * - id: Unique id for each option (note: we can have multiple entries for the same block type, but different defaultProps)
 * - type: Type of block to build when dropped on the page
 * - displayName: Label to display for each toolbox option
 * - icon: Icon to display for each toolbox option
 * - shouldEditOnDrop: Whether we should switch into edit mode immediately after dropping onto the page
 * - defaultConfig: Default block config we should use when creating a new block from this toolbox option
 */
export const blockToolboxOptions = [
  {
    id: 'text',
    type: 'text',
    displayName: 'Text',
    entityType: 'section',
    icon: faAlignLeft,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    shouldEditOnDrop: true,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'image',
    type: 'image',
    displayName: 'Image',
    icon: faImage,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    shouldEditOnDrop: true,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'table',
    type: 'table',
    displayName: 'Table',
    icon: faTable,
    iconSize: 32,
    shouldEditOnDrop: true,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { subtype: TABLE_TYPE.UNKNOWN } }
  },
  {
    id: 'line',
    type: 'line',
    displayName: 'Line Chart',
    entityType: 'chart',
    icon: faChartLine,
    iconSize: 32,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'bar',
    type: 'bar',
    displayName: 'Bar Chart',
    entityType: 'chart',
    icon: faChartSimple,
    iconSize: 33,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'map',
    type: 'map',
    displayName: 'Map',
    icon: faEarthAmerica,
    iconSize: 33,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'forest',
    type: 'forest',
    displayName: 'Forest Plot',
    entityType: 'chart',
    icon: forest,
    iconSize: 29,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'sankey',
    type: 'sankey',
    displayName: 'Sankey',
    icon: faDiagramSankey,
    iconSize: 29,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  },
  {
    id: 'sunburst',
    type: 'sunburst',
    displayName: 'Sunburst',
    icon: sunburst,
    iconSize: 33,
    primaryColor: colors.brandAccent,
    secondaryColor: colors.brandAccent,
    defaultConfig: { props: { placeholder: true } }
  }
]

/**
 * Rendering of the blockToolboxOptions as an object map
 */
export const blockToolboxOptionsMap = blockToolboxOptions.reduce((acc, obj) => {
  acc[obj.type] = obj
  return acc
}, {})
